import React from "react";
// import OptionAsahi from "./OptionAsahi";
import OptionHada from "./OptionHada";
import StemAsahi from "./StemAsahi";
import StemHada from "./StemHada";
const Tabs = ({ color }) => {
  const [openTab, setOpenTab] = React.useState(1);
  const svg =<svg class="h-6 w-6 text-orange-500 inline"  fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
</svg>

  return (
    <>
      <div className="flex flex-wrap">
        <div className="w-full">
          <ul
            className="flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row"
            role="tablist"
          >
            <li className="-mb-px mr-2 last:mr-0 flex-auto text-center">
              <a
                className={
                  "text-xl font-bold uppercase px-5 py-3  rounded block leading-normal" +
                  (openTab === 1
                    ? "text-white bg-" + color + "-600"
                    : "text-" + color + "-600 bg-white")
                }
                onClick={e => {
                  e.preventDefault();
                  setOpenTab(1);
                }}
                data-toggle="tab"
                href="#link1"
                role="tablist"
              >
                STEMONイオン高知旭町校
              </a>
            </li>
            <li className="-mb-px mr-2 last:mr-0 flex-auto text-center">
              <a
                className={
                  "text-xl font-bold uppercase px-5 py-3  rounded block leading-normal " +
                  (openTab === 2
                    ? "text-white bg-" + color + "-600"
                    : "text-" + color + "-600 bg-white")
                }
                onClick={e => {
                  e.preventDefault();
                  setOpenTab(2);
                }}
                data-toggle="tab"
                href="#link2"
                role="tablist"
              >
                 STEMON秦校
              </a>
            </li>
          </ul>
          <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6  border-0">
            <div className="px-4 py-5 flex-auto">
              <div className="tab-content tab-space">
                <div className={openTab === 1 ? "block" : "hidden"} id="link1">
                {/* イオン旭　str */}
                <h3>{svg}&nbsp;STEMONイオン高知旭町校&nbsp;を表示しています。</h3>
                <StemAsahi />
                {/* <OptionAsahi /> */}
                {/* イオン旭 End */}
                </div>
                <div className={openTab === 2 ? "block" : "hidden"} id="link2">
                  {/* 秦校　str */}
                  <h3>{svg}&nbsp;STEMON秦校&nbsp;を表示しています。</h3>
                  <StemHada />
                  <OptionHada />
                  {/* 秦校 End */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default function Tab() {
  return (
    <>
      <Tabs color="orange" />
    </>
  );
}
